import { DataGridWithCheckbox, type DataGridWithCheckboxProps } from '@shared/components';

export type BaseAddExamCenterMemberDataGridProps = Omit<
  DataGridWithCheckboxProps,
  'rowHeight' | 'disableColumnMenu' | 'sx'
>;

export default function BaseAddExamCenterMemberDataGrid(
  props: Readonly<BaseAddExamCenterMemberDataGridProps>,
) {
  return (
    <DataGridWithCheckbox
      {...props}
      rowHeight={68}
      disableColumnMenu
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
          alignItems: 'flex-start',
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
    />
  );
}
